import type { CityConfig } from "../city-template/types";

export const kannapolisConfig: CityConfig = {
  city: "Kannapolis",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "kannapolis",
  route: "/kannapolis",
  title: "Emergency Passport Kannapolis, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kannapolis, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cabarrus & Rowan County and the north Charlotte metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Kannapolis, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Kannapolis and north Charlotte metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Kannapolis%20North%20Carolina%20aerial%20cityscape%20view%20at%20golden%20hour%20with%20downtown%20revitalization%20district%2C%20modern%20Atrium%20Health%20Ballpark%20stadium%2C%20historic%20mill%20village%20buildings%2C%20wide%20tree-lined%20streets%20with%20American%20suburban%20charm%2C%20rolling%20green%20hills%20of%20Cabarrus%20County%20in%20background%2C%20warm%20sunset%20light%20with%20clean%20sky%2C%20professional%20architectural%20photography%20with%20warm%20earthy%20tones%20and%20southern%20growth%20corridor%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=kannapolis-hero-nc-001&orientation=landscape",
  heroImageAlt: "Kannapolis North Carolina downtown revitalization district with Atrium Health Ballpark and historic mill village at golden hour",
  geoPosition: "35.4875;-80.6217",
  geoPlacename: "Kannapolis, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 235 miles from Kannapolis via I-85",
  },
  nearbyCitiesZips: [
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Cornelius", zips: "28031" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Rockwell", zips: "28138" },
    { name: "China Grove", zips: "28023" },
    { name: "Landis", zips: "28088" },
    { name: "Midland", zips: "28107" },
    { name: "Locust", zips: "28097" },
    { name: "Mount Pleasant", zips: "28124" },
    { name: "Stanfield", zips: "28163" },
    { name: "Richfield", zips: "28137" },
    { name: "Albemarle", zips: "28001, 28002" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cabarrus and Rowan County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "North Charlotte Metro Hub", desc: "Serving Kannapolis, Concord, Salisbury, and the north Charlotte metro area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Fast passport renewal in Cornelius, NC", route: "/cornelius" },
    { name: "Emergency passport help in Davidson, NC", route: "/davidson" },
    { name: "Fast passport renewal in Concord, NC", route: "/concord-nc" },
    { name: "Emergency passport help in Huntersville, NC", route: "/huntersville" },
    { name: "Urgent passport services in Mooresville, NC", route: "/mooresville" },
    { name: "Same-day passport help in Raleigh, NC", route: "/raleigh" },
    { name: "Passport courier services in Greensboro, NC", route: "/greensboro" },
    { name: "Passport courier services in Matthews, NC", route: "/matthews" },
    { name: "Expedited passport services in Salisbury, NC", route: "/salisbury" },
    { name: "Fast passport renewal in Statesville, NC", route: "/statesville" },
    { name: "Passport courier services in Harrisburg, NC", route: "/harrisburg" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kannapolis remotely via secure courier. We do not have a walk-in office in Kannapolis — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cabarrus County, Rowan County, and the north Charlotte metro area travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Cabarrus County, Rowan County, and the north Charlotte metropolitan region",
  serviceAreaIntro: "From downtown Kannapolis' revitalized mill district to the suburban neighborhoods of Concord, from the historic streets of Salisbury to the Lake Norman communities of Mooresville, from the growing corridors of Harrisburg and Huntersville to the rural roads of China Grove and Rockwell — Fast Passport Center serves the entire Kannapolis region. We regularly help travelers from Charlotte, Davidson, Cornelius, and the north Charlotte metro area get their passports fast.",
  nearbyCitiesIntro: "We serve all Kannapolis neighborhoods and the surrounding north Charlotte metro area including Concord, Charlotte, Salisbury, Mooresville, Huntersville, Davidson, Cornelius, Harrisburg, Rockwell, China Grove, Landis, Midland, Locust, Mount Pleasant, Stanfield, Richfield, and Albemarle. If you are anywhere in Cabarrus County, Rowan County, or the northern Charlotte metropolitan area, we have you covered.",
  howItWorksIntro: "Most Kannapolis travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Kannapolis travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Kannapolis and Cabarrus County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Kannapolis? Here are the most common ones we hear from Cabarrus and Rowan County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Kannapolis international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jessica M.",
      location: "Kannapolis, NC",
      rating: 5,
      text: "My passport expired the week before my honeymoon cruise to the Caribbean. Fast Passport Center had my renewal ready in 36 hours. I never had to leave Kannapolis. The team was amazing.",
      service: "Passport Renewal",
    },
    {
      name: "David H.",
      location: "Concord, NC",
      rating: 5,
      text: "Emergency passport for a business trip to Germany. Got it in 28 hours. Fast Passport Center handled everything — I didn't even have to drive to Charlotte. Highly recommend for Cabarrus County.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda K.",
      location: "Salisbury, NC",
      rating: 5,
      text: "First passport for my 8-year-old before our family trip to Mexico. Fast Passport Center walked us through every step. Her passport was ready in 5 days and the process was so easy.",
      service: "Child Passport",
    },
    {
      name: "Robert P.",
      location: "Huntersville, NC",
      rating: 5,
      text: "Lost my passport 3 days before a conference in London. Fast Passport Center had a replacement to me in 30 hours. Their service across the north Charlotte metro is unbeatable.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "kannapolis-1",
      name: "Kannapolis Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1040 Dale Earnhardt Blvd",
      city: "Kannapolis",
      state: "NC",
      zip: "28083",
      phone: "(704) 938-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Kannapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kannapolis facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kannapolis-2",
      name: "Concord Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "80 Davidson Hwy",
      city: "Concord",
      state: "NC",
      zip: "28027",
      phone: "(704) 786-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles south of Kannapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility for Concord and Harrisburg residents. Photo services nearby at CVS and Walgreens.",
      icon: "ri-mail-line",
    },
    {
      id: "kannapolis-3",
      name: "Salisbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "620 W Innes St",
      city: "Salisbury",
      state: "NC",
      zip: "28144",
      phone: "(704) 636-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northeast of Kannapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rowan County and eastern Cabarrus County. Ample parking. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "kannapolis-4",
      name: "Mooresville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Plaza Dr",
      city: "Mooresville",
      state: "NC",
      zip: "28115",
      phone: "(704) 663-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Kannapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake Norman area and Iredell County. Good for Mooresville and Davidson residents.",
      icon: "ri-mail-line",
    },
    {
      id: "kannapolis-5",
      name: "Cabarrus County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "77 Union St S",
      city: "Concord",
      state: "NC",
      zip: "28025",
      phone: "(704) 262-5500",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "6 miles south of Kannapolis, Courthouse",
      website: "https://www.cabarruscounty.us/",
      websiteLabel: "Cabarrus County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "kannapolis-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles south of Kannapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Kannapolis photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cabarrus County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Kannapolis applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cabarrus County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Kannapolis travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Kannapolis." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kannapolis address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Kannapolis before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Kannapolis for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Kannapolis?", a: "Fast Passport Center offers fast passport renewal in Kannapolis in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Kannapolis?", a: "The nearest regional passport agency to Kannapolis is the Atlanta Passport Agency, approximately 235 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Kannapolis without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Kannapolis?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Kannapolis — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cabarrus and Rowan County residents." },
    { q: "Do you serve the entire north Charlotte metro area?", a: "Absolutely. Fast Passport Center serves the entire north Charlotte metropolitan area including Kannapolis, Concord, Charlotte, Salisbury, Mooresville, Huntersville, Davidson, Cornelius, Harrisburg, Rockwell, China Grove, Landis, Midland, Locust, Mount Pleasant, Stanfield, Richfield, and Albemarle. Our courier service works seamlessly from any address in Cabarrus County, Rowan County, and surrounding areas." },
    { q: "Can I expedite a child passport in Kannapolis?", a: "Yes. Fast Passport Center expedites child passports in Kannapolis for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Cabarrus and Rowan County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Kannapolis with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Kannapolis", address: "1020 Dale Earnhardt Blvd, Kannapolis, NC 28083", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Kannapolis", address: "1910 S Cannon Blvd, Kannapolis, NC 28083", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Kannapolis", address: "2420 Supercenter Dr NE, Kannapolis, NC 28083", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Concord", address: "5850 Bayfield Pkwy, Concord, NC 28027", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Concord", address: "3480 Concord Pkwy S, Concord, NC 28027", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Salisbury", address: "1011 E Innes St, Salisbury, NC 28144", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Mooresville", address: "585 River Hwy, Mooresville, NC 28117", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Kannapolis",
      address: "200 N Cannon Blvd, Kannapolis, NC 28083",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Concord",
      address: "6601 E Harris Blvd, Charlotte, NC 28215",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Mooresville",
      address: "118 Four Seasons Town Centre, Mooresville, NC 28117",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lake Norman area and Iredell County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Salisbury",
      address: "1415 W Innes St, Salisbury, NC 28144",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Rowan County and eastern Cabarrus area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "25 miles south of Kannapolis",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "60 miles northeast of Kannapolis",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "140 miles east of Kannapolis",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Cabarrus County Register of Deeds',
      description: 'Marriage licenses and records for Cabarrus County. Apply in person or request certified copies.',
      url: 'https://www.cabarruscounty.us/departments/register-of-deeds',
    },
    {
      label: 'Cabarrus County Clerk of Superior Court',
      description: 'Divorce records and decrees for Cabarrus County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/cabarrus-county/cabarrus-county-clerk-of-superior-court',
    },
  ],
};